import React from "react";
import { useTranslation } from "react-i18next";
import { SystemConstant } from "const";

const MessageStatus = ({ status }) => {
  const { t: getLabel } = useTranslation();

  const StatusLabel = () => {
    switch (status) {
      case SystemConstant.BOT_MESSAGE_STATUS.PENDING.status:
        return (
          <span className="badge" style={{ backgroundColor: "#FFE600", color: "#000", width: "130px", cursor: "default" }}>
            {getLabel(SystemConstant.BOT_MESSAGE_STATUS.PENDING.label)}
          </span>
        );
      case SystemConstant.BOT_MESSAGE_STATUS.SUCCESS.status:
        return (
          <span className="badge bg-success" style={{ width: "130px", cursor: "default" }}>
            {getLabel(SystemConstant.BOT_MESSAGE_STATUS.SUCCESS.label)}
          </span>
        );
      case SystemConstant.BOT_MESSAGE_STATUS.CANCELED.status:
        return (
          <span className="badge bg-danger" style={{ width: "130px", cursor: "default" }}>
            {getLabel(SystemConstant.BOT_MESSAGE_STATUS.CANCELED.label)}
          </span>
        );
      case SystemConstant.BOT_MESSAGE_STATUS.DRAFT.status:
        return (
          <span className="badge bg-warning" style={{ width: "130px", cursor: "default" }}>
            {getLabel(SystemConstant.BOT_MESSAGE_STATUS.DRAFT.label)}
          </span>
        );
      default:
        return (
          <span className="badge bg-danger" style={{ width: "130px", cursor: "default" }}>
            {getLabel(SystemConstant.BOT_MESSAGE_STATUS.FAILED.label)}
          </span>
        );
    }
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px", justifyContent: "center" }}>
      <StatusLabel />
    </div>
  );
};

export default MessageStatus;
